import { longgrassDisputeReasons } from 'ls-constants';
import { lsErrorService } from 'ls-vue-common';
import _ from 'lodash';

export const disputeStatus = {
    new: 'New',
    credit: 'Credit',
    completed: 'Completed',
    'pending.customer': 'Pending customer',
    'fix.declined': 'Fix declined',
    'fix.requested': 'Fix requested',
    'fix.scheduled': 'Fix scheduled',
    'fix.completed': 'Fix completed',
    'fix.voided': 'Fix voided',
    'partial_credit.applied': 'Partial credit applied',
    'feedback.sent': 'Feedback sent',
    'auto_redistributed.fix': 'Auto distribution fix',
    'auto_redistributed.credit': 'Auto distribution credit',
    'auto_redistributed.full_credit': 'Auto distribution full credit',
    expired: 'Expired',
    'declined.auto.new_pro_scheduled': 'Auto declined - Looking for new pro',
    'declined.auto.in_distribution': 'Fix declined - Looking for new pro',
    'contractor.new': 'Contractor new',
    denied: 'Denied',
    approved: 'Approved',
    'change.pro': 'Change Pro Requested',
    'fix.declined_with_evidence': 'Declined - Pro confirmed with evidence',
    'fix.refunded_and_redistributed': 'Refunded - Looking for new pro',
};

export function disputeStatusLabel(status) {
    if (disputeStatus[status]) {
        return disputeStatus[status];
    }

    lsErrorService.log({
        error: {
            message: 'Unmapped dispute status',
            level: 'error',
            extra: { dispute_status: status },
        },
    });

    return status || 'N/A';
}

export const longgrassDisputeReasonOptions = _.transform(
    longgrassDisputeReasons,
    (result, reason) => {
        reason = reason.reason || reason;
        result[reason.value] = reason.label;
    }
);

export const disputeReasonOptions = {
    'grass.uneven': 'Uneven mow',
    missedspots: 'Missed spots',
    edging: 'Bad edging',
    blowing: 'Issue blowing',
    'grass.long': 'Grass too long',
    other: 'Improve quality request',
    no_work_done: 'Believes no work completed',
    partial_complete: 'Partial complete',
    gate_open: 'Gate open',
    ...longgrassDisputeReasonOptions,
};

export const disputeReasonDetailsOptions = longgrassDisputeReasons
    .filter((reason) => !!reason.details)
    .reduce((result, { details }) => {
        details.forEach((detail) => (result[detail.value] = detail.label));
        return result;
    }, {});

export const evidenceRouteLabel = {
    photo_and_gps: 'Photo and GPS',
    photo_only: 'Photo only',
    gps_only: 'GPS only',
    none: 'No evidence',
};

// The customer's own option text, so agents see exactly what the customer chose.
const photoAnswerLabel = {
    work_done: 'Yes, this is a recent photo of my property',
    work_not_done: 'Yes, but it shows the work is not done',
    old_photo: "Yes, but it's an old photo of my property",
    missing_context: 'Yes, but it is missing important context',
    not_my_lawn: 'No, this is not my property',
};

// On the GPS route the customer answered a yes/no work-done question, not the photo question.
const gpsAnswerLabel = {
    work_done: 'Yes, there was work done',
    work_not_done: 'No, there was no work done',
};

export function customerContestAnswerLabel({ evidence_route, customer_contest_answer }) {
    const labels = evidence_route === 'gps_only' ? gpsAnswerLabel : photoAnswerLabel;

    return labels[customer_contest_answer] || 'N/A';
}
